import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Kanban.css";
import API_BASE_URL from "../config";

const KanbanBoard = (props) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const resolvedEmployeeId =
    props.employeeId || location.state?.employeeId || localStorage.getItem("employeeId");

  // Load Bootstrap dynamically
  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);

    const iconsLink = document.createElement("link");
    iconsLink.rel = "stylesheet";
    iconsLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(iconsLink);

    return () => {
      bootstrapLink.remove();
      iconsLink.remove();
    };
  }, []);

  // Fetch tasks for employee
  useEffect(() => {
    if (!resolvedEmployeeId || !token) {
      setLoading(false);
      return;
    }
    fetch(`${API_BASE_URL}/api/tasks/employee/${resolvedEmployeeId}`, {
      headers: { Authorization: "Bearer " + token },
    })
      .then((res) => res.json())
      .then((data) => {
        setTasks(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [resolvedEmployeeId, token]);

  const getTasksByStatus = (status) =>
    tasks.filter((task) => task.status === status);

  const columns = [
    { key: "PENDING", title: "TO DO" },
    { key: "IN_PROGRESS", title: "IN PROGRESS" },
    { key: "REVIEW", title: "REVIEW ✓" },
    { key: "COMPLETED", title: "DONE ✓" },
  ];

  const handleTaskClick = (taskId) => {
    navigate(`/viewtasks`); // navigate using task id
  };

  if (loading) return <div className="text-center my-5">Loading tasks...</div>;
  if (!resolvedEmployeeId)
    return (
      <div className="alert alert-warning text-center mt-4" role="alert">
        ⚠ No Employee ID provided. Please log in or select an employee.
      </div>
    );

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex gap-2">
          <input
            type="text"
            placeholder="Search board"
            className="form-control form-control-sm"
            style={{ width: "250px" }}
          />
          <button className="btn btn-outline-secondary btn-sm">
            <i className="bi bi-funnel"></i> Filter
          </button>
        </div>
        <button className="btn btn-primary btn-sm">Complete sprint</button>
      </div>

      <div className="row g-3">
        {columns.map((col) => (
          <div className="col-md-2" key={col.key}>
            <div className="kanban-column">
              <h5 className="fw-bold mb-3">{col.title}</h5>
              {getTasksByStatus(col.key).map((task) => (
                <div
                  key={task.id}
                  className="kanban-card mb-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleTaskClick(task.id)} // <-- use task.id
                >
                  {task.thumbnail && (
                    <img
                      src={task.thumbnail}
                      alt="task thumbnail"
                      className="img-fluid rounded mb-2"
                    />
                  )}
                  <h6 className="fw-semibold">{task.title}</h6>
                  <div className="d-flex flex-wrap gap-1 my-2">
                    {task.labels?.map((label, idx) => (
                      <span
                        key={idx}
                        className="badge bg-light text-dark border"
                      >
                        {label}
                      </span>
                    ))}
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    {task.dueDate && (
                      <span className="badge bg-danger-subtle text-danger border">
                        <i className="bi bi-calendar-event me-1"></i> {task.dueDate}
                      </span>
                    )}
                    <span className="badge bg-success-subtle text-success border">
                      {task.taskCode}
                    </span>
                    {task.assigneeInitials && (
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
                        style={{
                          width: "30px",
                          height: "30px",
                          backgroundColor: "#f0ad4e",
                          color: "white",
                        }}
                      >
                        {task.assigneeInitials}
                      </div>
                    )}
                  </div>
                </div>
              ))}
              {getTasksByStatus(col.key).length === 0 && (
                <div className="text-muted small text-center py-3">No tasks</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KanbanBoard;
